import { ButtonBase, ButtonBaseProps, styled, Typography } from '@mui/material';
import { blue } from '@mui/material/colors';
import React from 'react';
import Row from '../Layout/Row';

const StyledButtonBase = styled(ButtonBase)<{
  ownerState: { textDecoration: 'underline' | 'none' };
}>(({ ownerState }) => ({
  font: 'inherit',
  verticalAlign: 'baseline',
  textDecoration: ownerState.textDecoration,
  color: blue[500],
  '& .MuiSvgIcon-root': {
    color: blue[500],
  },
  '&.Mui-focusVisible': {
    outline: `2px solid ${blue[500]}`,
    outlineOffset: '1px',
    borderRadius: '2px',
  },
}));

type Props = Omit<ButtonBaseProps, 'variant'> & {
  text: string;
  to?: string;
  href?: string;
  textDecoration?: 'underline' | 'none';
  endAdornment?: React.ReactNode;
};

const TypographyButton: React.FC<Props> = ({
  text,
  textDecoration = 'underline',
  endAdornment,
  ...props
}) => {
  return (
    <Typography variant="inherit" display="inline">
      <StyledButtonBase ownerState={{ textDecoration }} {...props}>
        <Row centered>
          {text}
          {endAdornment}
        </Row>
      </StyledButtonBase>
    </Typography>
  );
};

export default TypographyButton;
